@if (show) {
  <app-standard-page class="payment-required">
    <app-standard-page-content [limitWidth]="true">
      <div class="p-3">
        <h3 class="text-warning">Action required</h3>

        <div class="row">
          <div class="col-12 col-lg-6">
            <p>
              This account is either overdue or over quota and is currently
              locked.
            </p>
            <p>
              Please ensure you have chosen a suitable subscription and make a
              payment to continue.
            </p>

            <a
              routerLink="/organisations/-/settings/organisation"
              fragment="payment"
              class="btn btn-outline"
              >Subscription & Payment</a
            >
          </div>
        </div>
      </div>
    </app-standard-page-content>
  </app-standard-page>
}
